import MultiBookkeepingList from "components/Picker/Bookkeeping/MultiBookkeepingList";
import React, { useContext, useEffect } from "react";
import { FilterContext } from "../FilterContext";
import { areArrayValuesEqual } from "../FilterGroups/instructionUtils";
import { getSortedBookkeepings, initialBookkeepingFilter } from "./FilterTypes/BookkeepingFilterType";
import MultiPickerFilterPopup from "./MultiPickerFilterPopup";

const BookkeepingFilter = () => {
  const title = RESX.Bookkeeping.resxBookkeeping;

  const { register, getValue, setInitialValue, setValue } = useContext(FilterContext);
  register("bookkeepings", {
    getTitle: () => title,
    renderSelection: (filter) => <>{getSortedBookkeepings(filter).join(", ")}</>,
    hasValue: (filter) => filter.selectedBookkeepings.length > 0,
    reset: () => initialBookkeepingFilter,
    areEqual: (a, b) => areArrayValuesEqual(a.selectedBookkeepings.map(b => b.bookkeepingId), b.selectedBookkeepings.map(b => b.bookkeepingId))
  });
  useEffect(() => {
    setInitialValue("bookkeepings", initialBookkeepingFilter);
  }, []);

  const [selectedBookkeepings, setSelectedBookkeepings] = React.useState<server.dto.BookkeepingSmall[]>(initialBookkeepingFilter.selectedBookkeepings);
  const [popupOpen, setPopupOpen] = React.useState<boolean>(false);

  const onPopupClose = () => {
    onApply();
  };

  const onPopupOpen = () => {
    setSelectedBookkeepings(getValue("bookkeepings").selectedBookkeepings);
    setPopupOpen(true);
  };

  const onApply = (e?) => {
    e?.preventDefault();
    setValue("bookkeepings", {
      selectedBookkeepings,
    });
    setPopupOpen(false);
  };

  return <div>
    <MultiPickerFilterPopup
      title={title}
      minHeight={350}
      width={400}
      open={popupOpen}
      onClose={onPopupClose}
      onOpen={onPopupOpen}
      onApply={onApply}
    >
      <MultiBookkeepingList
        value={selectedBookkeepings}
        bookkeepingSecurityScope="limitByUserAccess"
        onChange={setSelectedBookkeepings}
      />
    </MultiPickerFilterPopup>
  </div>;
};

export default BookkeepingFilter;
